module.exports = __webpack_public_path__ + "img/i-1.acdb92e4.jpg";